import { Send20Filled } from '@fluentui/react-icons';
import React from 'react';
import { useDispatch } from 'react-redux';
import localeService from 'src/dataServices/LocaleService';
import { setAddHeroBarListener } from 'src/state/contactus/actions';
import { sendHeroBarMessage } from './useCopilotHeroBarBridge';

export const CopilotHeroBar: React.FC = () => {
  const [message, setMessage] = React.useState('');
  const dispatch = useDispatch();

  // Signal the CopilotKit provider to listen for this hero bar's 'copilot-hero-send' events only
  // while it is mounted.
  React.useEffect(() => {
    dispatch(setAddHeroBarListener(true));
    return () => {
      dispatch(setAddHeroBarListener(false));
    };
  }, [dispatch]);

  // Suggestions are reserved for future phases — uncomment and wire up handleSuggestionClick to re-enable.
  // const suggestions = [
  //   { title: 'Check nonprofit eligiblity', message: 'How do I check if my nonprofit is eligible for offers?' },
  //   { title: 'How to register', message: 'How do I register my nonprofit organization?' },
  //   { title: 'Activate Azure credits', message: 'How can I activate Azure credits?' }
  // ];

  const handleSend = () => {
    const text = message.trim();
    if (!text) return;
    setMessage('');
    sendHeroBarMessage(text);
  };

  // Reserved for future phases — uncomment along with the suggestions array above to re-enable.
  // const handleSuggestionClick = async (text: string) => {
  //   setMessage('');
  //   await sendHeroBarMessage(text);
  // };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="copilot-hero-bar">
      <div className="copilot-hero-bar-header">
        <h2 className="copilot-hero-bar-title">{localeService.getText('ContactUs', 'CopilotHeroBarTitle')}</h2>
      </div>
      <div className="copilot-hero-bar-input-wrapper">
        <input
          type="text"
          className="copilot-hero-bar-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={localeService.getText('ContactUs', 'CopilotHeroBarPlaceholder')}
          aria-label={localeService.getText('ContactUs', 'CopilotHeroBarPlaceholder')}
        />
        <button
          className="copilot-hero-bar-send"
          onClick={handleSend}
          disabled={!message.trim()}
          aria-label={localeService.getText('ContactUs', 'CopilotHeroBarSendAriaLabel')}
        >
          <Send20Filled />
        </button>
      </div>
      {/* Suggestion chips — reserved for future phases. Uncomment to re-enable alongside the suggestions array and handleSuggestionClick above. */}
      {/* <div className="copilot-hero-bar-suggestions">
        {suggestions.map((s, i) => (
          <button key={i} className="copilot-hero-bar-suggestion" onClick={() => handleSuggestionClick(s.message)}>
            <span>{s.title}</span>
          </button>
        ))}
      </div> */}
    </div>
  );
};

